import PlayLayout from './playLayout.vue'

export default PlayLayout
